import * as yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';

interface ValidationMessage {
    SelectField(field: string): string;
    MinField(min: number, field: string): string;
    MaxField(max: number, field: string): string;
}

const local_language = localStorage.getItem('lang')


const CompanyProfileValidation: any = yup.object().shape({
    location: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("vendndodhjen") : ValidationMessage.Field("location")),

    description: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("përshkrimi") : ValidationMessage.Field("description"))
        .min(50, local_language == "alb" ? ValidationMessageAlbanian.MinLength('përshkrimi', 50) : ValidationMessage?.MinLength('description', 50))
        .max(300, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('përshkrimi', 300) : ValidationMessage?.MaxLength('description', 300)),


    category: yup.array().of(yup.string()).min(1, local_language == "alb" ? ValidationMessageAlbanian.SelectField("kategori") : ValidationMessage.SelectField("category")).required(),
    services: yup.array().min(1, local_language == "alb" ? "Ju lutemi shkruani shërbimet" : 'Please enter services.').required(local_language == "alb" ? "Ju lutemi shkruani shërbimet" : 'Please enter services.'),
 

    image: yup.array().of(
        yup.object().shape({
            file_path: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.SelectField("imazh") : ValidationMessage.SelectField("image")),
            media_id: yup.string().nullable(), // Allow media_id to be null or a string
        })
    ).min(5, local_language == "alb" ? ValidationMessageAlbanian.MinLength('imazh', 5) : ValidationMessage.MinField(5, "image")).max(10, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('imazh', 10) : ValidationMessage.MaxField(10, "image")).required(),

    ownerimage: yup.string().required(local_language == "alb" ? 'Ju lutemi zgjidhni dëshminë e pronarit të sallonit' : 'Please select proof of Salon Owner.'), // Corrected validation message
});



// image: yup.mixed()
// .test('required', ValidationMessage.SelectField('image'))



export default CompanyProfileValidation;

